/**
 * @generated SignedSource<<586ea904dac2c3c077281ae8633e307f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useSbSharedPageTracking_viewer$data = {
  readonly isEligibleForRerank?: boolean | null;
  readonly " $fragmentType": "useSbSharedPageTracking_viewer";
};
export type useSbSharedPageTracking_viewer$key = {
  readonly " $data"?: useSbSharedPageTracking_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"useSbSharedPageTracking_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isClient"
    },
    {
      "kind": "RootArgument",
      "name": "rerankGuestId"
    },
    {
      "kind": "RootArgument",
      "name": "rerankUserId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useSbSharedPageTracking_viewer",
  "selections": [
    {
      "condition": "isClient",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "guestId",
              "variableName": "rerankGuestId"
            },
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "rerankUserId"
            }
          ],
          "kind": "ScalarField",
          "name": "isEligibleForRerank",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "86eee4b375a011efb624946eda057c65";

export default node;
